import React from 'react';

import {
  IcCancelFullScreenIcon,
  IcFullScreenIcon,
  IcMiniplayerWebIcon,
  IcPauseIcon,
  IcPlayIcon,
} from '@gem/icons';

import { IconButton } from '../../../IconButton/IconButton';
import { MediaPlayerProgress } from '../../components/MediaPlayerProgress/MediaPlayerProgress';
import { VideoPlayerType } from '../VideoPlayer.constants';
import { VideoPlayerSpeed } from '../VideoPlayerSpeed/VideoPlayerSpeed';
import { VideoPlayerTime } from '../VideoPlayerTime/VideoPlayerTime';
import { VideoPlayerVolume } from '../VideoPlayerVolume/VideoPlayerVolume';
import styles from './VideoPlayerDefaultControls.styles.m.css';

export const VideoPlayerDefaultControls = ({
  isPlaying,
  onPlay,
  onPause,
  onTogglePlay,
  progress,
  progressMax,
  progressBuffer,
  onSetProgress,
  onProgressSelection,
  isMuted,
  volume,
  onToggleMute,
  onSetVolume,
  onVolumeSelection,
  currentSpeed,
  setSpeed,
  onToggleSpeedPopover,
  onShowMiniPlayer,
  isFullScreenMode,
  onToggleFullScreenMode,
  normalSpeedText,
}) => {
  return (
    <div className={styles.controls}>
      <MediaPlayerProgress
        className={styles.progress}
        isPlaying={isPlaying}
        progress={progress}
        progressMax={progressMax}
        progressBuffer={progressBuffer}
        onPlay={onPlay}
        onPause={onPause}
        onProgress={onSetProgress}
        onProgressSelection={onProgressSelection}
      />

      <div className={styles.actionsPanel}>
        <div className={styles.actions}>
          <IconButton
            className={styles.actionButton}
            Icon={isPlaying ? IcPauseIcon : IcPlayIcon}
            size="x-small"
            iconSize="medium"
            theme="19"
            onClick={onTogglePlay}
          />

          <VideoPlayerVolume
            isMuted={isMuted}
            volume={volume}
            onToggleMute={onToggleMute}
            onSetVolume={onSetVolume}
            onVolumeSelection={onVolumeSelection}
          />

          <VideoPlayerTime
            type={VideoPlayerType.Default}
            progress={progress}
            progressMax={progressMax}
          />
        </div>

        <div className={styles.actions}>
          <VideoPlayerSpeed
            normalSpeedText={normalSpeedText}
            currentSpeed={currentSpeed}
            onSpeedChange={setSpeed}
            onToggleSpeedPopover={onToggleSpeedPopover}
          />

          {onShowMiniPlayer && (
            <IconButton
              className={styles.actionButton}
              Icon={IcMiniplayerWebIcon}
              size="x-small"
              iconSize="medium"
              theme="19"
              onClick={onShowMiniPlayer}
            />
          )}

          <IconButton
            className={styles.actionButton}
            Icon={!isFullScreenMode ? IcFullScreenIcon : IcCancelFullScreenIcon}
            size="x-small"
            iconSize="medium"
            theme="19"
            onClick={onToggleFullScreenMode}
          />
        </div>
      </div>
    </div>
  );
};
